import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import {
    Colours,
    Sizes,
    CircleSpinner,
    ZIndex,
} from '@ratehub/base-ui';


function DocumentHistoryTable({ model, RowComponent, shouldShowSpinner }) {
    return (
        <Container>
            <Choose>
                <When condition={model.activeRows && model.activeRows.length > 0}>
                    <For
                        each="row"
                        of={model.activeRows}
                    >
                        <li
                            className="dashboard-document-row"
                            key={row.key}
                        >
                            <RowComponent
                                model={model}
                                onRemoveRow={() => model.removeRow(model.selectedTabIndex, row)}
                                {...row}
                            />
                        </li>
                    </For>
                </When>
                <Otherwise>
                    <li
                        className="dashboard-document-row"
                    >
                        <RowComponent />
                    </li>
                </Otherwise>
            </Choose>
            <If condition={shouldShowSpinner}>
                <CircleSpinner zIndex={ZIndex.ELEMENTS} />
            </If>
        </Container>
    );
}

DocumentHistoryTable.propTypes = {
    model: PropTypes.object,
    RowComponent: PropTypes.object.isRequired,
    shouldShowSpinner: PropTypes.bool,
};

DocumentHistoryTable.defaultProps = {
    model: undefined,
    shouldShowSpinner: false,
};

const Container = styled.div`
    padding: 0;
    margin: 0;

    > .dashboard-document-row {
        list-style: none;

        border: solid 1px ${Colours.STONE};
        border-radius: 6px;

        margin-bottom: ${Sizes.SPACING.HALF};
    }
`;

export default observer(DocumentHistoryTable);
